import styled from 'styled-components';

import media from 'apps/auth/theme/media';
import zIndex from 'apps/auth/theme/zIndex';

export const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
    align-items: center;
    user-select: none;
    position: relative;
`;
export const ProgressRow = styled.div`
    display: flex;
    flex-direction: row;
    padding: 0 24px;
    width: 100%;
    max-width: 552px;
    box-sizing: border-box;
    position: absolute;
    top: 12px;
    z-index: ${zIndex.storiesProgress};

    ${media.tablet720} {
        top: 16px;
    }
`;

export const Step = styled.div`
    display: inline-flex;
    flex-grow: 1;
    height: 2px;
    border-radius: 4px;
    background: ${(props) => props.theme.grey_28_tr};
    margin-right: 4px;
    position: relative;

    &:last-child {
        margin-right: 0;
    }
`;
interface StepBgProps {
    isInverted?: boolean;
}

export const StepBg = styled.div<StepBgProps>`
    height: 2px;
    border-radius: 4px;
    background: ${(props) => (props.isInverted ? props.theme.white_base : props.theme.purple_100)};
`;

export const Overlay = styled.div`
    display: flex;
    flex-direction: row;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    div {
        width: 50%;
    }
`;
